const NotFound = () => <><h2>Error 404: The page you are looking for doesn&apos;t exist</h2></>;

export default NotFound;
